import React from "react";

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-4">
      <header className="bg-blue-600 text-white p-4 text-center">
        <h1 className="text-xl font-bold">Privacy Policy / سياسة الخصوصية</h1>
      </header>

      <main className="container mx-auto mt-8 p-4 bg-white rounded shadow-lg">
        {/* Introduction Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Introduction / المقدمة
          </h2>
          <p className="mb-2">
            Welcome to Tarbaa. We are committed to respecting your privacy and
            protecting your personal data. This Privacy Policy outlines how we
            collect, use, and protect information you provide when using our
            application.
            <br />
            مرحبًا بكم في ترَبَّع. نحن ملتزمون باحترام خصوصيتكم وحماية بياناتكم
            الشخصية. توضح سياسة الخصوصية هذه كيفية جمع واستخدام وحماية المعلومات
            التي تقدمونها عند استخدام تطبيقنا.
          </p>
        </section>

        {/* Data Collection and Use Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Data Collection and Use / جمع البيانات واستخدامها
          </h2>
          <p className="mb-2">
            We collect the following information:
            <br />
            • Email address: Used for account authentication, communication, and
            account recovery
            <br />
            • Username: Used to identify you within the application
            <br />
            • Password: Fully encrypted and securely stored using
            industry-standard encryption methods for account authentication
            <br />
            • Subscription data: Information related to your subscription status
            and purchases
            <br />
            • Game progress and preferences: To provide a personalized gaming
            experience
            <br />
            <br />
            نقوم بجمع المعلومات التالية:
            <br />
            • عنوان البريد الإلكتروني: يستخدم للمصادقة والتواصل واسترداد الحساب
            <br />
            • اسم المستخدم: يستخدم لتعريفك داخل التطبيق
            <br />
            • كلمة المرور: مشفرة بالكامل ومخزنة بشكل آمن باستخدام طرق تشفير
            قياسية في الصناعة للمصادقة
            <br />
            • بيانات الاشتراك: معلومات متعلقة بحالة اشتراكك والمشتريات
            <br />• تقدم اللعبة والتفضيلات: لتوفير تجربة لعب مخصصة
          </p>
        </section>

        {/* Subscription Information */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Subscription Information / معلومات الاشتراك
          </h2>
          <p className="mb-2">
            Our app offers auto-renewable subscriptions. Payment will be charged
            to your Apple ID account at confirmation of purchase. Subscriptions
            automatically renew unless auto-renew is turned off at least
            24-hours before the end of the current period. Your account will be
            charged for renewal within 24-hours prior to the end of the current
            period. Subscriptions may be managed and auto-renewal may be turned
            off by going to your Account Settings after purchase.
            <br />
            <br />
            يقدم تطبيقنا اشتراكات تتجدد تلقائيًا. سيتم خصم الدفع من حساب Apple
            ID الخاص بك عند تأكيد الشراء. تتجدد الاشتراكات تلقائيًا ما لم يتم
            إيقاف التجديد التلقائي قبل 24 ساعة على الأقل من نهاية الفترة
            الحالية. سيتم خصم رسوم التجديد من حسابك خلال 24 ساعة قبل نهاية
            الفترة الحالية. يمكن إدارة الاشتراكات وإيقاف التجديد التلقائي من
            خلال الذهاب إلى إعدادات الحساب بعد الشراء.
          </p>
        </section>

        {/* Data Sharing Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Data Sharing / مشاركة البيانات
          </h2>
          <p className="mb-2">
            We do not sell or rent your personal data to third parties. However,
            we may share certain data with service providers that help us
            operate our application, process payments, and analyze usage
            patterns. These service providers are bound by confidentiality
            agreements and are not permitted to use your personal data for any
            other purposes.
            <br />
            <br />
            نحن لا نبيع أو نؤجر بياناتك الشخصية لأطراف ثالثة. ومع ذلك، قد نشارك
            بعض البيانات مع مزودي الخدمة الذين يساعدوننا في تشغيل تطبيقنا،
            ومعالجة المدفوعات، وتحليل أنماط الاستخدام. هؤلاء مقيدون باتفاقيات
            السرية ولا يُسمح لهم باستخدام بياناتك الشخصية لأي أغراض أخرى.
          </p>
        </section>

        {/* User Rights Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Your Rights / حقوقكم</h2>
          <p className="mb-2">
            As a user, you have the right to:
            <br />
            • Access the personal data we hold about you
            <br />
            • Request correction of your personal data
            <br />
            • Delete your account and associated data
            <br />
            • Change your password and update your profile information
            <br />
            • Manage your subscription preferences
            <br />
            <br />
            To exercise these rights, please contact us at tarbaa.kw@gmail.com.
            <br />
            <br />
            كمستخدم، لديك الحق في:
            <br />
            • الوصول إلى البيانات الشخصية التي نحتفظ بها عنك
            <br />
            • طلب تصحيح بياناتك الشخصية
            <br />
            • حذف حسابك والبيانات المرتبطة به
            <br />
            • تغيير كلمة المرور وتحديث معلومات ملفك الشخصي
            <br />
            • إدارة تفضيلات الاشتراك الخاصة بك
            <br />
            <br />
            لممارسة هذه الحقوق، يرجى الاتصال بنا على tarbaa.kw@gmail.com.
          </p>
        </section>

        {/* Data Security Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Data Security / أمان البيانات
          </h2>
          <p className="mb-2">
            We implement appropriate security measures to protect your personal
            data, including encryption of sensitive information, secure password
            hashing, and regular security audits of our systems. While no method
            of transmission over the Internet or electronic storage is 100%
            secure, we strive to use commercially acceptable means to protect
            your personal data.
            <br />
            <br />
            نقوم بتطبيق تدابير أمنية مناسبة لحماية بياناتك الشخصية، بما في ذلك
            تشفير المعلومات الحساسة، وتشفير كلمات المرور بشكل آمن، وإجراء عمليات
            تدقيق أمنية منتظمة لأنظمتنا. على الرغم من أنه لا توجد طريقة للنقل
            عبر الإنترنت أو التخزين الإلكتروني آمنة بنسبة 100٪، فإننا نسعى
            جاهدين لاستخدام وسائل مقبولة تجاريًا لحماية بياناتك الشخصية.
          </p>
        </section>

        {/* Changes to This Policy Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Changes to This Policy / تغييرات على هذه السياسة
          </h2>
          <p className="mb-2">
            We may update our Privacy Policy from time to time. We will notify
            you of any changes by posting the new Privacy Policy on this page
            and updating the "Last Updated" date. You are advised to review this
            Privacy Policy periodically for any changes.
            <br />
            <br />
            قد نقوم بتحديث سياسة الخصوصية الخاصة بنا من وقت لآخر. سنُخطركم بأي
            تغييرات من خلال نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث
            تاريخ "آخر تحديث". ننصحكم بمراجعة سياسة الخصوصية هذه بشكل دوري لأي
            تغييرات.
          </p>
        </section>

        {/* Terms of Use Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">
            Terms of Use / شروط الاستخدام
          </h2>
          <p className="mb-2">
            By using our application, you also agree to our Terms of Use (EULA),
            which can be found at:
            <a
              href="https://www.tarbaa.com/terms"
              className="text-blue-600 hover:underline"
            >
              {" "}
              https://www.tarbaa.com/terms
            </a>
            <br />
            <br />
            باستخدام تطبيقنا، فإنك توافق أيضًا على شروط الاستخدام (EULA) الخاصة
            بنا، والتي يمكن العثور عليها على:
            <a
              href="https://www.tarbaa.com/terms"
              className="text-blue-600 hover:underline"
            >
              {" "}
              https://www.tarbaa.com/terms
            </a>
          </p>
        </section>

        {/* Contact Section */}
        <section>
          <h2 className="text-2xl font-semibold mb-4">Contact Us / اتصل بنا</h2>
          <p className="mb-2">
            If you have any questions about this Privacy Policy or our data
            practices, please contact us at tarbaa.kw@gmail.com.
            <br />
            <br />
            إذا كان لديكم أي أسئلة حول سياسة الخصوصية هذه أو ممارسات البيانات
            لدينا، يرجى الاتصال بنا على tarbaa.kw@gmail.com.
          </p>
        </section>

        {/* Last Updated Section */}
        <section className="mt-8 text-gray-600">
          <p>Last Updated: Apr 2025 / آخر تحديث: ابريل 2025</p>
        </section>
      </main>

      <footer className="bg-gray-800 text-white text-center p-4 mt-8">
        <p>© 2025 ترَبَّع. All rights reserved. / جميع الحقوق محفوظة.</p>
        <div className="mt-2">
          <a
            href="https://www.tarbaa.com/privacy"
            className="text-blue-300 hover:underline mx-2"
          >
            Privacy Policy
          </a>
          <a
            href="https://www.tarbaa.com/terms"
            className="text-blue-300 hover:underline mx-2"
          >
            Terms of Use
          </a>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;
